module.exports = __webpack_public_path__ + "static/img/promotion2.0dfd6f1d.png";